import { useHistory, useParams } from 'react-router-dom'
import { PAGES } from '../../router/routes'
import { parametrosNotaFiscalStyles } from './ParametrosNotaFiscal.styles'

export function parametrosNotaFiscalIO() {
  const rotas = useHistory()
  const { parceiroId } = useParams<{ parceiroId: string }>()

  const handleChange = () => {
    rotas.push(PAGES.transformacaoNotaFiscal(parceiroId))
  }

  return {
    styles: parametrosNotaFiscalStyles,
    handleChange
  }
}

export type ParametrosNotaFiscalIO = ReturnType<typeof parametrosNotaFiscalIO>
